import { API_URL, getApiV1BaseUrl } from '@/constants'

export async function fetchUserFrontend() {
  return await fetch(`${getApiV1BaseUrl()}${API_URL.USERS.CURRENT_USER}`, {
    credentials: 'include',
  })
}
